import { render, staticRenderFns } from "./SearchRewardRequestsHeader.vue?vue&type=template&id=eb4398d6&"
import script from "./SearchRewardRequestsHeader.vue?vue&type=script&lang=js&"
export * from "./SearchRewardRequestsHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchRewardRequestsHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports